import React from 'react';

const MissionPage = ({ setActiveTab }) => {
  return (
    <div className="mission-container">
      <div className="mission-header">
        <h1>Nuestra Misión</h1>
        <p>Transformar el mercado inmobiliario con tecnología inteligente</p>
      </div>

      {/* Mission Statement */}
      <div className="mission-statement-section">
        <div className="mission-content">
          <h2>Democratizar el acceso a propiedades perfectas</h2>
          <p className="mission-text">
            Creemos que encontrar la propiedad ideal no debería ser un proceso frustrante, 
            lento o limitado por herramientas obsoletas. Nuestra misión es utilizar la 
            inteligencia artificial para hacer que cada persona en Costa Rica pueda 
            encontrar su hogar perfecto de manera rápida, precisa y sin esfuerzo.
          </p>
        </div>
      </div>

      {/* Vision */}
      <div className="vision-section">
        <h2>Nuestra Visión</h2>
        <div className="vision-grid">
          <div className="vision-card">
            <div className="vision-icon">🌟</div>
            <h3>Futuro Sin Filtros</h3>
            <p>Un mundo donde no necesites configurar docenas de filtros para encontrar lo que buscas</p>
          </div>
          
          <div className="vision-card">
            <div className="vision-icon">🤖</div>
            <h3>IA Como Asistente Personal</h3>
            <p>Cada persona tendrá un asistente inteligente que entiende sus necesidades únicas</p>
          </div>
          
          <div className="vision-card">
            <div className="vision-icon">⚡</div>
            <h3>Transacciones Instantáneas</h3>
            <p>Procesos que toman meses se completarán en días gracias a la automatización</p>
          </div>
        </div>
      </div>

      {/* The Problem We Solve */}
      <div className="problem-section">
        <h2>El Problema que Resolvemos</h2>
        <div className="problem-content">
          <div className="problem-item">
            <h3>❌ Herramientas Obsoletas</h3>
            <p>Los sitios web inmobiliarios siguen usando la misma tecnología de hace 30 años</p>
          </div>
          
          <div className="problem-item">
            <h3>❌ Búsquedas Limitadas</h3>
            <p>Los filtros tradicionales no capturan la complejidad de lo que realmente buscas</p>
          </div>
          
          <div className="problem-item">
            <h3>❌ Oportunidades Perdidas</h3>
            <p>Las propiedades perfectas se pierden porque no aparecen en búsquedas mal configuradas</p>
          </div>
          
          <div className="problem-item">
            <h3>❌ Procesos Lentos</h3>
            <p>Encontrar, evaluar y comprar una propiedad toma demasiado tiempo</p>
          </div>
        </div>
      </div>

      {/* Our Solution */}
      <div className="solution-section">
        <h2>Nuestra Solución</h2>
        <div className="solution-content">
          <div className="solution-highlight">
            <h3>🤖 Inteligencia Artificial Conversacional</h3>
            <p>
              Nuestro asistente IA entiende el lenguaje natural. En lugar de configurar filtros, 
              simplemente describes lo que buscas como si hablaras con un amigo experto en bienes raíces.
            </p>
          </div>
          
          <div className="solution-benefits">
            <div className="benefit">
              <h4>Comprensión Profunda</h4>
              <p>Entiende contexto, preferencias implícitas y necesidades no expresadas</p>
            </div>
            
            <div className="benefit">
              <h4>Búsqueda Exhaustiva</h4>
              <p>Rastrea múltiples fuentes y bases de datos simultáneamente</p>
            </div>
            
            <div className="benefit">
              <h4>Aprendizaje Personalizado</h4>
              <p>Mejora sus recomendaciones basándose en tus preferencias y feedback</p>
            </div>
            
            <div className="benefit">
              <h4>Disponibilidad 24/7</h4>
              <p>Tu asistente personal está disponible cuando lo necesites</p>
            </div>
          </div>
        </div>
      </div>

      {/* Impact Goals */}
      <div className="impact-section">
        <h2>Nuestro Impacto Esperado</h2>
        <div className="impact-stats">
          <div className="stat-card">
            <div className="stat-label">Reducción en tiempo de búsqueda</div>
          </div>
          
          <div className="stat-card">
            <div className="stat-label">Menos propiedades perdidas</div>
          </div>
      
        </div>
      </div>

      {/* Call to Action */}
      <div className="mission-cta-section">
        <div className="cta-content">
          <h2>Únete a la Revolución Inmobiliaria</h2>
          <p>
            Sé parte del cambio. Experimenta cómo la inteligencia artificial puede 
            transformar tu búsqueda de propiedades.
          </p>
          <div className="cta-buttons">
            <button 
              className="button-primary"
              onClick={() => setActiveTab('contact')}
            >
              Contactanos
            </button>
            <button 
              className="button-secondary"
              onClick={() => setActiveTab('about')}
            >
              Conocer Más
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MissionPage;
